import React from "react";
import Imgs from "../image/images";
import { IoIosArrowDropdown } from "react-icons/io";
import { MdCancel } from "react-icons/md";
import style1 from "./workout.module.css"

const Legsworkout = () =>{
    const Fun = () =>{
        var x = document.getElementById("abs");
        var y = document.getElementById("plank");
        x.style.display= "block";
        y.style.position = "absolute";
        y.style.top = "64%"
    }
    const Delete = () =>{
        var y = document.getElementById("abs");
        var x = document.getElementById("plank");
        y.style.display = "none";
        x.style.position = "absolute";
        x.style.top = "50%"
    }
    const Fun1 = () =>{
        var x1 = document.getElementById("crunch");
        var y1 = document.getElementById("crunch1");
        x1.style.display = "block";
        y1.style.position = "absolute";
        y1.style.top = "64%"
    }
    const Delete1 = () =>{
        var y1 = document.getElementById("crunch");
        var x1 = document.getElementById("crunch1");
        y1.style.display = "none";
        x1.style.position = "absolute";
        x1.style.top = "50%"
    }
    const Fun2 = () =>{
        var x1 = document.getElementById("twist");
        var y1 = document.getElementById("crunch2");
        x1.style.display = "block";
        y1.style.position = "absolute";
        y1.style.top = "64%"
    }
    const Delete2 = () =>{
        var x1 = document.getElementById("crunch2");
        var y1 = document.getElementById("twist");
        y1.style.display = "none";
        x1.style.position = "absolute";
        x1.style.top = "50%"
    }
    const Func = () =>{
        var x1 = document.getElementById("p");
        x1.style.display = "block";
        var y = document.getElementById("plank");
        y.style.position = "absolute";
        y.style.top = "45%"
    }
    const Deletec = () =>{
        var y1 = document.getElementById("p");
        y1.style.display = "none";
        var y = document.getElementById("plank");
        y.style.position = "absolute";
        y.style.top = "50%"
    }
    const Func1 = () =>{
        var x1 = document.getElementById("c");
        x1.style.display = "block";
        var y1 = document.getElementById("crunch1");
        y1.style.position = "absolute";
        y1.style.top = "45%"
    }
    const Deletec1 = () =>{
        var y1 = document.getElementById("c");
        y1.style.display = "none";
        var y = document.getElementById("crunch1");
        y.style.position = "absolute";
        y.style.top = "50%"
    }
    const Func2 = () =>{
        var x1 = document.getElementById("c2");
        x1.style.display = "block";
        var y1 = document.getElementById("crunch2");
        y1.style.position = "absolute";
        y1.style.top = "45%"
    }
    const Deletec2 = () =>{
        var y1 = document.getElementById("c2");
        y1.style.display = "none";
        var y = document.getElementById("crunch2");
        y.style.position = "absolute";
        y.style.top = "50%"
    }
    return (
        <>
            <div className={style1.head1}>
                <h1 className={style1.name}>Legs Workout</h1>
                <img src={Imgs.logo} alt="not_found" className={style1.logo}/>
            </div>
            <div className={style1.body1}>
                <div className={style1.ex1}>
                    <p className={style1.p1}>Squat</p>
                    <IoIosArrowDropdown style={{color: 'white',fontSize: '25px',position: 'absolute',left: '88%',top: '30%',cursor: 'pointer'}}  onClick={()=>Fun()}/>
                    <div className={style1.box1}>
                        <img src="https://media.post.rvohealth.io/wp-content/uploads/2019/03/Female_Squat_Studio_732x549-thumbnail-2.jpg" alt="" />
                    </div>
                    <div className={style1.video1} id="abs">
                        <MdCancel style={{fontSize: '25px',cursor:'pointer',position: 'absolute',left: '90%',top: '1%'}} onClick={()=>Delete()}/>
                        <video src={Imgs.video9} controls width={350} height={200}></video>
                    </div>
                </div>
                <div className={style1.ex2}>
                    <p className={style1.p2}>Lunge</p>
                    <IoIosArrowDropdown style={{color: 'white',fontSize: '25px',position: 'absolute',left: '88%',top: '30%',cursor: 'pointer'}}  onClick={()=>Fun1()}/>
                    <div className={style1.box2}>
                        <img src="https://upload.wikimedia.org/wikipedia/commons/2/29/Airman_performing_lunge.jpg" alt="" />
                    </div>
                    <div className={style1.video2} id="crunch">
                        <MdCancel style={{fontSize: '25px',cursor:'pointer',position: 'absolute',left: '90%',top: '1%'}} onClick={()=>Delete1()}/>
                        <video src={Imgs.video10} controls width={350} height={200}></video>
                    </div>
                </div>
                <div className={style1.ex3}>
                    <p className={style1.p3}>Jump Squat</p>
                    <IoIosArrowDropdown style={{color: 'white',fontSize: '25px',position: 'absolute',left: '88%',top: '30%',cursor: 'pointer'}}  onClick={()=>Fun2()}/>
                    <div className={style1.box3}>
                        <img src="https://i.ytimg.com/vi/CVaEhXotL7M/maxresdefault.jpg" alt="" />
                    </div>
                    <div className={style1.video3} id="twist">
                        <MdCancel style={{fontSize: '25px',cursor:'pointer',position: 'absolute',left: '90%',top: '1%'}} onClick={()=>Delete2()}/>
                        <video src={Imgs.video11} controls width={350} height={200}></video>
                    </div>
                </div>
                <div className={style1.ex4} id="plank">
                    <p className={style1.p1}>Calf Raises</p>
                    <IoIosArrowDropdown style={{color: 'white',fontSize: '25px',position: 'absolute',left: '88%',top: '30%',cursor: 'pointer'}}  onClick={()=>Func()}/>
                    <div className={style1.box1}>
                        <img src="https://cdn-0.weighttraining.guide/wp-content/uploads/2016/10/Lever-Standing-Calf-Raise-resized.png?ezimgfmt=ng%3Awebp%2Fngcb4" alt="" />
                    </div>
                    <div className={style1.video1} id="p">
                        <MdCancel style={{fontSize: '25px',cursor:'pointer',position: 'absolute',left: '90%',top: '1%'}} onClick={()=>Deletec()}/>
                        <video src={Imgs.video27} controls width={350} height={200}></video>
                    </div>
                </div>
                <div className={style1.ex5} id="crunch1">
                    <p className={style1.p1}>Bulgarian split squat</p>
                    <IoIosArrowDropdown style={{color: 'white',fontSize: '25px',position: 'absolute',left: '88%',top: '30%',cursor: 'pointer'}}  onClick={()=>Func1()}/>
                    <div className={style1.box1}>
                        <img src="https://hips.hearstapps.com/hmg-prod/images/split-squat-1541799833.jpg" alt="" />
                    </div>
                    <div className={style1.video1} id="c">
                        <MdCancel style={{fontSize: '25px',cursor:'pointer',position: 'absolute',left: '90%',top: '1%'}} onClick={()=>Deletec1()}/>
                        <video src={Imgs.video28} controls width={350} height={200}></video>
                    </div>
                </div>
                <div className={style1.ex6} id="crunch2">
                    <p className={style1.p1}>Side Lunge</p>
                    <IoIosArrowDropdown style={{color: 'white',fontSize: '25px',position: 'absolute',left: '88%',top: '30%',cursor: 'pointer'}}  onClick={()=>Func2()}/>
                    <div className={style1.box1}>
                        <img src="https://hips.hearstapps.com/hmg-prod/images/side-lunge-1543424933.jpg" alt="" />
                    </div>
                    <div className={style1.video1} id="c2">
                        <MdCancel style={{fontSize: '25px',cursor:'pointer',position: 'absolute',left: '90%',top: '1%'}} onClick={()=>Deletec2()}/>
                        <video src={Imgs.video29} controls width={350} height={200}></video>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Legsworkout;